module.exports = __webpack_public_path__ + "static/img/yy17.6fba81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy17.png
// module id = Wv0J
// module chunks = 1